import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/layout/login';
import NoLogin from '@/views/layout/no-login';
import Data from '@/views/layout/data';
import Qms from '@/views/layout/qms';
import QmsTemplate from '@/views/layout/qmsTemplate';
import doRouter from '@/views/qms/dp-router/index';

Vue.use(Router)
export const constantRouterMap = [
  {
    path: '/',
    name: 'index',
    redirect: '/home-index'
  },
  {
    path: '/',
    name: 'home',
    component:() => import("@/views/home/index"),
    children:[
      {
        path:'home-index',
        name:'homeIndex',
        component: () => import("@/views/home/home")
      },
      {
        path:'help',
        name:'help',
        component: () => import("@/views/home/help")
      },
      {
        path:'home-template',
        name:'homeTemplate',
        component: () => import("@/views/home/template")
      },
      {
        path:'template-pre/:id',
        name:'templatePreview',
        component: () => import("@/views/home/template-pre")
      },
      {
        path:'sample',
        name:'sample',
        component: () => import("@/views/home/sample")
      },

      {
        path: 'login',
        name: 'login',
        component: () => import('@/views/user/login'),
      }
    ]
  },
  {
    path: '/add',
    name: 'add',
    component:() => import("@/views/qms/add"),
  },
  {
    path: '/add-quota/:id',
    name: 'add-quota',
    component:() => import("@/views/qms/quota/add"),
  },
  // 问卷类表
  {
    path: '/',
    name: 'list',
    component: Login,
    children: [
      {
        path: 'list',
        name: 'listIndex',
        component: () => import('@/views/qms/list')
      },
      {
        path: 'data-user',
        name: 'dataUser',
        component: () => import('@/views/qms/data-user')
      },
      {
        path: '/operation-log',
        name: 'operation-log',
        component: () => import('@/views/qms/operationLog')
      },
      {
        path: '/preview-test/:id',
        name: 'previewIndex',
        component: () => import('@/views/qms/preview')
      },
      {
        path: 'end',
        name: 'end',
        component: () => import('@/views/qms/end')
      },

    ]
  },
  {
    path: '/qms/template',
    name: 'list',
    component: Login,
    children: [
      {
        path: 'index',
        name: 'template',
        component: () => import('@/views/qms/template/index'),
      },
      {
        path: 'type',
        name: 'template',
        component: () => import('@/views/qms/template/type'),
      }
    ]
  },
  {
    path: '/qms/template',
    name: 'list',
    component: QmsTemplate,
    children: [
      {
        path: 'edit/:id',
        name: 'template',
        component: () => import('@/views/qms/template/question/edit'),
      },
      {
        path: 'theme/:id',
        name: 'template',
        component: () => import('@/views/qms/template/question/theme'),
      },

    ]
  },
  {
    path: '/report/',
    name: 'report-data',
    component: Data,
    children: [
      //会员校对
      {
        path: 'member/:id',
        name: 'member-id',
        component:() => import("@/views/member/index"),
      },
      //小票校对
      {
        path: 'receipt/:id',
        name: 'receipt-id',
        component:() => import("@/views/receipt/index"),
      },
      {
        path: 'quota-info',
        name: 'quota-info',
        component: () => import('@/views/qms/quota-info'),
      },
      {
        path: ':id',
        name: 'report-id',
        component: () => import('@/views/qms/report')
      },
      {
        path: 'custom/:id',
        name: 'custom-id',
        component: () => import('@/views/qms/custom')
      },
      {
        path: 'cross/:id',
        name: 'custom-id',
        component: () => import('@/views/qms/cross')
      },
      {
        path: 'quota/:id',
        name: 'quota-id',
        component: () => import('@/views/qms/quota'),
      },
      {
        path: 'answer/:id',
        name: 'quota-id',
        component: () => import('@/views/qms/answer'),
      },
      {
        path: 'gen/:id',
        name: 'gen-id',
        component: () => import('@/views/qms/gen'),
      },
      {
        path: 'dp/:id',
        name: 'dp-id',
        component: doRouter,
        children:[
          {
            path: 'data',
            name: 'dp-data',
            component: () => import('@/views/qms/dp')
          },
          {
            path: 'query',
            name: 'dp-query',
            component: () => import('@/views/qms/dp-info')
          },
          {
            path: 'crossQuery',
            name: 'dp-crossQuery',
            component: () => import('@/views/qms/crossDp-info')
          }
        ]
      },
      {
        path: 'export/:id',
        name: 'export-id',
        component: () => import('@/views/qms/export')
      },
      {
        path: 'picture/:id',
        name: 'picture-id',
        component: () => import('@/views/qms/picture')
      },
    ]
  },
  // 编辑问卷
  {
    path: '/edit/',
    name: 'edit',
    component: Qms,
    children: [
      {
        path: 'theme/:id',
        name: 'theme',
        component: () => import('@/views/qms/theme'),
      },
      {
        path: 'visit/:id',
        name: 'visit',
        component: () => import('@/views/qms/visit'),
      },
      {
        path: ':id',
        name: 'edit-id',
        component: () => import('@/views/qms/edit'),
      },
      {
        path: 'quota/:id',
        name: 'quota-id',
        component: () => import('@/views/qms/quota'),
      },
      {
        path: 'logic/:id',
        name: 'logic-id',
        component: () => import('@/views/qms/logic'),
      },
      {
        path: 'label/:id',
        name: 'label-id',
        component: () => import('@/views/qms/label'),
      },
      {
        path: 'ceshi/:id',
        name: 'ceshi-id',
        component: () => import('@/views/qms/ceshi'),
      },
      {
        path: 'storeNum/:id',
        name: 'storeNum-id',
        component: () => import('@/views/qms/storeNum'),
      },
      {
        path: 'template/:id',
        name: 'template-id',
        component: () => import('@/views/qms/template'),
      },
      {
        path: 'form/:id',
        name: 'form-id',
        component: () => import('@/views/qms/form'),
      },

    ]
  },
  // 编辑问卷
  {
    path: '/q-type-list',
    name: 'qTypeList',
    component: Login,
    children: [
      {
        path: '',
        name: 'qTypeIndex',
        component: () => import('@/views/qms/type/qTypeList')
      }
    ]
  },
  {
    path: '/user',
    name: 'user',
    component: Login,
    children: [
      {
        path: '',
        name: 'user',
        component: () => import('@/views/user')
      }
    ]
  },

  // 测试组件
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/test')
  },
  {
    path: '/progress/:id',
    name: 'progress',
    component: () => import('@/views/qms/progress')
  },
  {
    name: 'symposium',
    path: '/symposium',
    component: Login,
    children:[
      {
        path:':id',
        name:'symposiumIndex',
        component: () => import("@/views/symposium/index")
      },
      {
        path:'dashboard/:id',
        name:'symposiumDashboard',
        component: () => import("@/views/symposium/dashboard/index")
      },
    ]
  },
  //数据看板
  {
    path: '/panel',
    name: 'panel',
    component: () => import('@/views/qms/panel')
  },
  // 登录
  /*发布*/
  {
    path: '/release/:id',
    name: 'edit',
    component: Login,
    children: [
      {
        path: '',
        name: '',
        component: () => import('@/views/qms/release'),
      }
    ]
  },
  {
    path: '/packet/:id',
    name: 'packet',
    component: Login,
    children: [
      {
        path: '',
        name: '',
        component: () => import('@/views/qms/redpacket'),
      }
    ]
  },
  {
    path: '/check_error/:id',
    name: 'edit',
    component: Login,
    children: [
      {
        path: '',
        name: '',
        component: () => import('@/views/qms/checkError'),
      }
    ]
  },
  /*  {
      path: '/quota',
      name: 'quota',
      component: Login,
      children:[
        {
          path:'',
          name:'',
          component: () => import('@/views/qms/quota'),
        }
      ]
    },*/
  /*数据*/
  {
    path: '/data/:id',
    name: 'data',
    component: Login,
    children: [
      {
        path: '',
        name: '',
        component: () => import('@/views/qms/data'),
      }
    ]
  },
  {
    path: '/quota/:id',
    name: 'quota-id',
    component: () => import('@/views/qms/quota/publicQuota'),
  }
]
export default new Router({
  mode: 'history', // 后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js